import { useEffect, useState } from "react";
import HomePage from "./components/HomePage";
import Login from "./components/Login";
import { ThemeProvider } from "styled-components";
import { THEMES, Theme } from "./models/Colors";
import YesterdayScores from "./components/YesterdayScores";
import { Page, Tab } from "./components/Common";
import Header from "./components/Header";
import ThemeSelector from "./components/ThemeSelector";
import Footer from "./components/Footer";
import { BadgeWorkshopTab } from "./components/Badges";
import { ActiveUserContext } from "./utils/contexts";
import StatisticsPage from "./components/StatisticsPage";
import { getProfileById, updateProfile } from "./api/Profile.api";

function App() {
  const [userId, setUserId] = useState("");
  const [theme, setTheme] = useState(THEMES[0]);
  const [currentTab, setCurrentTab] = useState<Tab>("homepage");

  useEffect(() => {
    document.body.style.backgroundColor = theme.BACKGROUND;
    const name = window.localStorage.getItem("username");
    if (name) {
      setUserId(name);
      getProfileById(name).then((profile) => {
        if (profile) setTheme(profile.theme);
      });
    }
  }, [theme.BACKGROUND]);

  const onSubmitName = (name: string) => {
    const trimmedName = name.trim();
    window.localStorage.setItem("username", trimmedName);
    setUserId(trimmedName);
    getProfileById(trimmedName).then((profile) => {
      if (profile) setTheme(profile.theme);
    });
  };

  const onLogout = () => {
    window.localStorage.removeItem("username");
    setUserId("");
  };

  const onThemeChange = () => {
    if (currentTab !== "theme") navigate("theme");
    else navigate("homepage");
  };

  const onThemeSelect = (t: Theme) => {
    setTheme(t);
    updateProfile({ userId, theme: t });
    navigate("homepage");
  };

  const navigate = (t: Tab) => {
    setCurrentTab(t);
  };

  const renderTab = (currentTab: Tab): JSX.Element => {
    switch (currentTab) {
      case "homepage":
        return <HomePage userId={userId} navigate={navigate} />;
      case "theme":
        return <ThemeSelector onThemeSelect={onThemeSelect} />;
      case "yesterday":
        return <YesterdayScores userId={userId} navigate={navigate} />;
      case "badges":
        return <BadgeWorkshopTab />;
      case "statistics":
        return <StatisticsPage navigate={navigate} />;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <ActiveUserContext.Provider value={userId}>
        <Page>
          {userId ? (
            <>
              <Header
                userId={userId}
                onThemeChange={onThemeChange}
                onLogout={onLogout}
              />
              {renderTab(currentTab)}
              <Footer />
            </>
          ) : (
            <Login onSubmitName={onSubmitName} />
          )}
        </Page>
      </ActiveUserContext.Provider>
    </ThemeProvider>
  );
}

export default App;
